// Import axios library
import axios from "axios";

// Server Api Url
const serverUrl = `${process.env.REACT_APP_API_HOST}`;

// Create an instance of axios with the base URL and headers
const axiosClient = axios.create({
  baseURL: serverUrl,
  headers: {
    Accept: "application/json",
  },
});

// Intercept requests and add token to header if present in local storage
axiosClient.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("adminToken");
  const userToken = localStorage.getItem("jwtToken");
  const isAdminPage = window.location.pathname.startsWith("/admin");
  const token = isAdminPage ? (adminToken || userToken) : userToken;
  if (token && token !== "" && token !== "null")
    config.headers["token"] = token;
  return config;
});

// Intercept responses and redirect to login page if unauthorized
axiosClient.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    // error.response is undefined when the request never got a reply (server
    // down, CORS, connection refused). Reading .status off it used to throw a
    // TypeError here, which replaced the real axios error for every caller —
    // so callers lost the status and the server's message, and could only show
    // a generic failure. Keep this null-safe.
    console.log('error in api index', error, error?.response);
    if (error?.response?.status === 401) {
      // localStorage.removeItem("jwtToken");
      // localStorage.removeItem("user");
      // window.location = "/";
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Export the axios client instance
export default axiosClient;
